import {createAsyncThunk} from "@reduxjs/toolkit";
import {setValue} from "./redcuers";
import {fetchPlaylist} from "../../api/playlist/playlistApi";
import {RootState} from "../../store";
import {updateRecentlyPlayed} from "../user/actions";

export const getPlaylist = createAsyncThunk<void, string, { state: RootState }>('player/getPlaylist',
    async (playlistId: string, {dispatch, getState}) => {

        const {recentlyPlayed} = getState().user;

        if(recentlyPlayed[playlistId]) {
            dispatch(updateRecentlyPlayed(recentlyPlayed[playlistId]));
            return;
        }

        dispatch(setValue({key: 'isLoading', value: true}));
        dispatch(setValue({key: 'error', value: ''}));

        const response = await fetchPlaylist(playlistId);

        if (response.ok) {
            dispatch(setValue({key: 'isLoading', value: false}))
            dispatch(updateRecentlyPlayed(response.value));
        } else {
            dispatch(setValue({key: 'error', value: response.err}))
            dispatch(setValue({key: 'isLoading', value: false}))
        }
    }
);

export type PlaylistActions = ReturnType<
    typeof getPlaylist
>;
